import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissaoRecursoService } from '../permissao-recurso.service';

@Injectable()
export class PermissaoRecursoGuard implements CanActivate {

  constructor(private _permissaoRecursoService: PermissaoRecursoService){}

  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this._permissaoRecursoService.temPermissao(next);
  }


}
